/**
 * Service for announcements.
 *
 * Responsibilities:
 * - Fetch announcements.
 * - Fetch last seen announcement marker.
 * - Delete an announcement by id.
 */
import type { IAnnouncements } from "../types";
import type { ApiClient } from "@/common/api/http/types";

export default class AnnouncementsService {
  public constructor(private readonly client: ApiClient) {}

  async getAnnouncements(): Promise<IAnnouncements> {
    return await this.client.get("v2/announcements");
  }

  async getLastSeenAnnouncement(): Promise<{ id: string }> {
    return await this.client.get("v2/announcements/last-seen");
  }

  async deleteAnnouncement(id: string): Promise<void> {
    return await this.client.delete(`v2/announcements/${id}`);
  }
}
